import { useEffect } from 'react'

export const PIXEL_ID = '1012201387645029'

export const useMetaPixel = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const win = window as any

    if (win.fbq) return // Already initialized

    const n = (win.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!win._fbq) win._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []

    const t = document.createElement('script')
    t.async = !0
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'

    const s = document.getElementsByTagName('script')[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      document.head.appendChild(t)
    }

    win.fbq('init', PIXEL_ID)
    win.fbq('track', 'PageView')
  }, [])
}

export const trackAddToCart = () => {
  if (typeof window !== 'undefined') {
    const win = window as any
    if (win.fbq) {
      win.fbq('track', 'AddToCart')
    }
  }
}
